import { useEffect, useRef, useState } from "react";
import loca_log from "../assets/logo.png";

const { kakao } = window;

const Contact = () => {
  const [active, setActive] = useState("");
  const mapRef = useRef(null);

  useEffect(() => {
    const container = mapRef.current;
    let options = {
      center: new kakao.maps.LatLng(37.52289, 126.9021),
      level: 4,
    };
    let map = new kakao.maps.Map(container, options);

    let markerPosition = new kakao.maps.LatLng(37.52289, 126.9021);
    let marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //사이즈 변경시 탭 활성화 설정
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1023) {
        setActive("active");
      } else {
        setActive("");
      }
    }
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div className="sub-visual subv-4">
        <h1>
          <span>CONTACT</span>
          <p>최적의 정보 시스템 서비스를 제공합니다.</p>
        </h1>
        <div className="sub-depth-1">
          <ul>
            <li id="contact" className={active}>
              Contact Us
            </li>
          </ul>
        </div>
      </div>

      <section className="sec-wrap">
        <section className="sec-centent">
          <div id="sub" className="contactus">
            <div className="cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2 className="big">Contact Us</h2>
                </div>
                <div className="con-tab active" data-id="con-tab1">
                  <div className="map" ref={mapRef}></div>
                  <div className="map-info">
                    <div className="tplat-logo">
                      <img src={loca_log} alt="회사로고" />
                      <span className="sr-only">JENIX</span>
                    </div>
                    <ul className="info-list">
                      <li>
                        <strong className="tit">Address</strong>
                        <span className="det">
                          서울시 영등포구 영신로 166 반도아이비밸리 413호
                        </span>
                      </li>
                      <li>
                        <strong className="tit">Tel</strong>
                        <span className="det">&nbsp;02-861-4716</span>
                      </li>
                      <p className="tit-wr">
                        <strong className="tit">Email</strong>
                        <span className="det">
                          &nbsp;kissis@jenixinfo.co.kr
                        </span>
                      </p>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Contact;
